import { render } from "./TermsOfServiceView.vue?vue&type=template&id=d09e2666&scoped=true"
import script from "./TermsOfServiceView.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceView.vue?vue&type=script&lang=js"

import "./TermsOfServiceView.vue?vue&type=style&index=0&id=d09e2666&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d09e2666"]])

export default __exports__